(function () {
    'use strict';
    angular
        .module('cog.shared')
        .service('CogApiServiceProvider', CogApiServiceProvider);
    /* @ngInject */
    function CogApiServiceProvider(localStorageService, CogBMService: any, cogApiService: IApiService, accountService: IAccountService ) {
        var service: ICogApiServiceProvider = {
            apiAccService: getApiAccService,
            apiCogService: getApiCogService,            
            is_BM: is_BM,
            setBetType: setBetType,
            getCustomerKey: getCustomerKey,
            setIsCustomer: setIsCustomer,
        };
        return service;
        ////////////     
        function getApiAccService(): any {
            var isBM: boolean = is_BM();
            if (!isBM) {
                return accountService;
            } else {
                return CogBMService;
            }
        }

        function setIsCustomer() {
            CogBMService.unsetIsBM();
        }

        function getApiCogService(): any {
            var isBM: boolean = is_BM();
            if (!isBM) {
                return cogApiService;
            } else {
                return CogBMService;
            }
        }

        function is_BM(): boolean {
            var is_bm: boolean = false;
            if (CogBMService != null)
                is_bm = CogBMService.isBM();
            return is_bm;
        }

        function setBetType(bt: any): void {
            var isBM: boolean = is_BM();
            if (!isBM) {
                accountService.setBetSelection(bt);
            } else {
                CogBMService.setBetType(bt);
            }
        }

        function getCustomerKey(): string {
            var ckey: string = "";
            var isBM = is_BM();
            if (isBM) {
                ckey = CogBMService.getCustomerKey();
            }
            return ckey;
        }        
    }
})();
